import React from 'react'
import DropDownWindowStyle from './css/DropDownWindowStyle'

function DropDownWindow(props) {
  return (
    <React.Fragment>
      <div id='dropdown-window'>
        {props.children}
      </div>
      <DropDownWindowStyle />
    </React.Fragment>
  )
}

export default React.memo(DropDownWindow)
